// config.js
export const MAPBOX_ACCESS_TOKEN =   "pk.eyJ1Ijoicm1hcGRldiIsImEiOiJjbTIzM3pjcHUwMXM0MmtzNjBvYWVoYjBwIn0.8HWOwE3EwFXu7fTewVXcOQ";
